// extracted by mini-css-extract-plugin
export var container = "_hc-1";
export var cornerButtonContainer = "_hc-6";
export var disabled = "_hc-2";
export var dragActive = "_hc-3";
export var fileContainer = "_hc-5";
export var hiddenInput = "_hc-4";
export var widthContainer = "_hc-0";